module.exports = __webpack_public_path__ + "img/MATCH.a776964b.png";